import type { FaireProductEntity } from "../../entity_types/product";

export const p_7j9yl6zx: FaireProductEntity = {
  token: "p_7j9yl6zx",
  type: "product",
  name: "Piñon - Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/57a6f0d7f189a1e998649c668fc3075fa946dda436cafec92ffd2aef0b38f670.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6dc22da852f72036bd0e75942cdea0eaba05ec65a354543db1c0063917f571f5.jpeg",
    "https://cdn.faire.com/fastly/57def00cbd07198cded855e5478108a3afbd7d2faa2781f6b84275ec3d96ae7a.jpeg",
    "https://cdn.faire.com/fastly/684b102beb292a8c2e638fa6b79287989799edc67f2cadc7c36e8ea7a1d05877.jpeg",
    "https://cdn.faire.com/fastly/41db24fd9063c264330da38383dae63613a26b7f136eac29b3b925821c80ec91.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/9d0bd272bd3218e678e2ad4d572062a04d096c083b603c5391706273149cb761.jpeg",
  ],
  priceDollars: 5,
  description:
    'Winters in the Southwest, lingering bonfires, wool jackets in rotation. Notes of piñon logs, cedar, and vanilla.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:45.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
